import { render, staticRenderFns } from "./DragAndDropImages.vue?vue&type=template&id=4246f139&scoped=true"
import script from "./DragAndDropImages.vue?vue&type=script&lang=js"
export * from "./DragAndDropImages.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropImages.vue?vue&type=style&index=0&id=4246f139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246f139",
  null
  
)

export default component.exports